import React, { useEffect, useState } from "react";
import { HiOutlineEnvelope } from "react-icons/hi2";
import nigeriaFlag from '../../assets/img/flag/nigeria-flag.png'
import { updateUserProfile } from "../../actions/auth";
import { useDispatch } from "react-redux";

const ProfileForm = ({userDetails}) => {
    const [formData, setFormData] = useState({
      first_name: userDetails?.first_name || "",
      last_name: userDetails?.last_name || "",
      phone: userDetails?.phone || "",
      username: userDetails?.username || "",
      address: userDetails?.address || "",
      city: userDetails?.city || "",
      state: userDetails?.state || "",
      country: userDetails?.country || "",
    });
    const dispatch = useDispatch();
    const [isEdited, setIsEdited] = useState(false); 
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const kycNotDone = userDetails?.kyc_profile == null || ['started', 'failed', 'expired'].includes(userDetails?.kyc_profile?.status);

    // Handle input changes
    const handleChange = (e) => {
      const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setIsEdited(true);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!isEdited) {
          setErrorMessage("No changes detected.");
          return;
      }

      // Get updated fields only
      const updatedFields = {
        first_name: formData.first_name,
        last_name: formData.last_name,
      };

      Object.keys(formData).forEach((key) => {
          if (formData[key] && formData[key] !== userDetails[key]) {
              updatedFields[key] = formData[key];
          }
      });

      if (!updatedFields.first_name) {
          updatedFields.first_name = userDetails?.first_name;
      }
      if (!updatedFields.last_name) {
          updatedFields.last_name = userDetails?.last_name;
      }

      const onlyNamesUpdated =
          Object.keys(updatedFields).length === 2 &&
          updatedFields.first_name === userDetails?.first_name &&
          updatedFields.last_name === userDetails?.last_name;

      if (onlyNamesUpdated) {
          setErrorMessage("No changes detected.");
          return;
      }

      const userId = userDetails?.id;

      await updateUserProfile(updatedFields, userId, setLoading, setSuccessMessage, setErrorMessage, setIsEdited, dispatch); 
    };

  return (
    <div className="profile-form-container">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>First Name</label>
          <input type="text" name="first_name" className="form-control" value={formData.first_name} 
          onChange={handleChange} disabled={!kycNotDone} readOnly={!kycNotDone} />
        </div>

        <div className="form-group">
          <label>Last Name (Surname)</label>
          <input type="text" name="last_name" className="form-control" 
            value={formData.last_name} onChange={handleChange} disabled={!kycNotDone} readOnly={!kycNotDone}/>
        </div>

        <div className="form-group">
          <label>Username</label>
          <input type="text" name="username" className="form-control" 
          value={formData.username || ''} onChange={handleChange}/>
        </div>

        <div className="form-group">
          <label>Email Address</label>
          <div className="input-group">
            <span className="input-group-text">
              <HiOutlineEnvelope size={30} />
            </span>
            <input type="email" className="form-control" value={userDetails?.email} readOnly />
          </div>
        </div>

        {errorMessage && <p className="text-center error-container">{errorMessage}</p>}
        {successMessage && <p className="text-center success-container">{successMessage}</p>}

        <button type="submit" className="btn save-btn mt-5" disabled={!isEdited || loading}>
          {loading ? (
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            "Save changes"
          )}
        </button>
      </form>
    </div>
  );
};

export default ProfileForm;
